import { stringifyQuery } from "@/utils/query";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  CommonStandardAttachmentsGet200Response,
  MasterApiCommonStandardAttachmentsGetRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosRequestConfig } from "axios";
import { MasterInstance } from "@/instance/axios";

export const commonDocument_QueryKey = "commonDocuments" as const;

export const commonDocuments = createQueryKeys(commonDocument_QueryKey, {
  all: null,
  get: (
    params: MasterApiCommonStandardAttachmentsGetRequest,
    option?: AxiosRequestConfig,
  ) => {
    const parsedParams: MasterApiCommonStandardAttachmentsGetRequest = {
      ...params,
      query: stringifyQuery(params?.query),
      sort:
        typeof params.sort === "string" && params.sort.trim().length > 0
          ? params.sort
          : "-id",
    };
    return {
      queryKey: [parsedParams],
      queryFn: async (): Promise<CommonStandardAttachmentsGet200Response> => {
        const response =
          await MasterInstance.commonStandardAttachmentUserViewGet(
            parsedParams,
            option,
          );
        return response.data;
      },
    };
  },
});
